import React,  { useState ,useEffect} from 'react';
import "../Agestpagamentos.css";
import parseISO from 'date-fns/parseISO';
import subDays from 'date-fns/subDays';
import format from 'date-fns/format';
import {Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, RadialBarChart, RadialBar,AreaChart,PieChart,Pie,  Sector,Legend, Cell,Tooltip,CartesianGrid,XAxis,YAxis, Area,ResponsiveContainer} from 'recharts';

function AGestPagamentos() {
  const [diariod,setDiariod]=useState({m3:"",tsc:"",iva:"",valor:"",total:""});
  const datass = [
    {
      subject: 'M_PESA',
      A: 120,
      B: 110,
      C:30,
      fullMark: 150,
    },
    {
      subject: 'E_MOLA',
      A: 98,
      B: 130,
      C:56,
     
      fullMark: 150,
    },
    {
      subject: 'VISA',
      A: 86,
      B: 130,
      C:10,
     
      fullMark: 150,
    },
    {
      subject: 'RecargaAKI',
      A: 99,
      B: 100,
      C:127,
     
      fullMark: 150,
    },
    {
      subject:'PayPal',
      A: 85,
      B: 90,
      C:123,
     
      fullMark: 150,
    },
    {
      subject: 'PONTO24',
      A: 65,
      B: 85,
      C:120,
     
      fullMark: 150,
    },
  ];
  const datas=[];
  for(let num=2;num>=0;num--){
    datas.push({
        date:subDays(new Date(),num).toISOString().substr(0,10),
        value:1+Math.random(),
        mpesa:1-Math.random(),
        emola:0.5*Math.random(),
    })
}
  const COLORS = ['#053f40', '#ca2210', '#ffa500'];
  const style = {
    top: '50%',
    right: 0,
    transform: 'translate(0, -50%)',
    lineHeight: '24px',
  };

  const data = [
       
    {
      name: 'TSC',
      uv: 56.69,
      pv: 4567,
      fill: '#00FF00',
    },
    {
      name: 'IVA',
      uv: 50.69,
      pv: 1398,
      fill: '#8dd1e1',
    },
    {
        name: 'Lucro',
        uv: 80   ,
        pv: 4800,
        fill: '#053f40',
      },
    {
      name: 'TOTAL',
      uv: 100   ,
      pv: 4800,
      fill: '#ffc658',
    },
  ];

  return <div id="Apagamentos">
    <div className='Totais'>

                    <div className='info'>
                        <div id="icon"><img  id="imagem_vendas"src={require('./images/tax.png')} /></div>
                        <div id="txts">Total Pago:</div>
                        <div id='valor'>{diariod.total} Mzn</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon"><img  id="imagem_vendas"src={require('./images/visa.png')} /></div>
                        <div id="txts">Visa:</div>
                        <div id='valor'>0 Mzn</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon"><img  id="imagem_vendas"src={require('./images/24-hours.png')} /></div>
                        <div id="txts">Conta Movel:</div>
                        <div id='valor'>0 Mzn</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon"><img  id="imagem_vendas"src={require('./images/paypal.png')} /></div>
                        <div id="txts">PayPal:</div>
                        <div id='valor'>0 Mzn</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon"><img  id="imagem_vendas"src={require('./images/payment-method.png')} /></div>
                        <div id="txts">M pesa:</div>
                        <div id='valor'>0 Mzn</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon"><img  id="imagem_vendas"src={require('./images/pos-terminal.png')} /></div>
                        <div id="txts">RecargaAki:</div>
                        <div id='valor'>0 Mzn</div>
                    </div>
                    <div className='info'>
                        <div id="icon"><img  id="imagem_vendas"src={require('./images/seller.png')} /></div>
                        <div id="txts">Revendedor:</div>
                        <div id='valor'>{diariod.total} Mzn</div>
                    </div>
                                      
            </div>
            <div className='Totais'>

<div className='info'>
    <div id="icon"><img  id="imagem_vendas"src={require('./images/tax.png')} /></div>
    <div id="txts">Total Pago:</div>
    <div id='valor'>{diariod.total} Mzn</div>
    
</div>
<div className='info'>
    <div id="icon"><img  id="imagem_vendas"src={require('./images/visa.png')} /></div>
    <div id="txts">Conta Registada Na API</div>
    <div id='valor'>4333 7321 2312 2341</div>
    <div className='Filtro'>
        <button  id="opcao" value="Nao"  >Desativar</button>
        <button  id="opcao" value="Nao"  >Requisitar Edicao</button>
      
        </div>
      
    
</div>
<div className='info'>
    <div id="icon"><img  id="imagem_vendas"src={require('./images/24-hours.png')} /></div>
    <div id="txts">Conta Registada Na API</div>
    <div id='valor'>+258848911419</div>
    <div className='Filtro'>
        <button  id="opcao" value="Nao"  >Desativar</button>
        <button  id="opcao" value="Nao"  >Requisitar Edicao</button>
      
        </div>
    
</div>
<div className='info'>
    <div id="icon"><img  id="imagem_vendas"src={require('./images/paypal.png')} /></div>
    <div id="txts">Conta Registada Na API</div>
    <div id='valor'>enhkogas@gmail.com</div>
    <div className='Filtro'>
        <button  id="opcao" value="Nao"  >Desativar</button>
        <button  id="opcao" value="Nao"  >Requisitar Edicao</button>
      
        </div>
    
</div>
<div className='info'>
    <div id="icon"><img  id="imagem_vendas"src={require('./images/payment-method.png')} /></div>
    <div id="txts">Conta Registada Na API</div>
    <div id='valor'>613 426</div>
    <div className='Filtro'>
        <button  id="opcao" value="Nao"  >Desativar</button>
        <button  id="opcao" value="Nao"  >Requisitar Edicao</button>
      
        </div>
    
</div>
<div className='info'>
    <div id="icon"><img  id="imagem_vendas"src={require('./images/pos-terminal.png')} /></div>
    <div id="txts">Conta Registada Na API</div>
    <div id='valor'>2345 5431 2345 2214</div>
    <div className='Filtro'>
        <button  id="opcao" value="Nao"  >Desativar</button>
        <button  id="opcao" value="Nao"  >Requisitar Edicao</button>
      
        </div>
   
</div>
<div className='info'>
    <div id="icon"><img  id="imagem_vendas"src={require('./images/seller.png')} /></div>
    <div id="txts">Conta Registada Na API</div>
    <div id='valor'>4333 7321 2312 2341</div>
    <div className='Filtro'>
        <button  id="opcao" value="Nao"  >Desativar</button>
        <button  id="opcao" value="Nao"  >Requisitar Edicao</button>
      
        </div>
   
  </div>
                  
</div>


            <ResponsiveContainer   >
            <PieChart >
            <Pie
            data={datas}
            cx={120}
            cy={90}
            innerRadius={60}
            outerRadius={80}
            fill="#8884d8"
            paddingAngle={5}
            dataKey="value"
                     >
            {datas.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
            
            </Pie>
   
                <Tooltip/>
            </PieChart>
          
        </ResponsiveContainer>
       
       
            
  </div>;
}

export default AGestPagamentos;
